module.exports = __webpack_public_path__ + "static/DSC_9470-1361ff541188adbd234139d340f06c3e.jpg";